<header class="topbar">
  <div class="topbar-left">
    <button class="menu-toggle" (click)="menuToggle.emit()">
      <i class="pi pi-bars"></i>
    </button>
    <span class="page-title">{{ pageTitleKey() | translate }}</span>
  </div>

  <div class="topbar-right">

    <!-- Global Quick Lookup -->
    <div class="global-search">
      <span class="search-icon"><i class="pi pi-search"></i></span>
      <input pInputText
        [ngModel]="searchQuery()"
        (ngModelChange)="onSearch($event)"
        [placeholder]="'common.quickSearch' | translate"
        class="search-input"
        (focus)="searchOpen.set(searchResults().length > 0)"
        (blur)="searchOpen.set(false)"
      />
      @if (searchOpen() && searchResults().length > 0) {
        <div class="search-dropdown" (mousedown)="$event.preventDefault()">
          @for (r of searchResults(); track r.route) {
            <div class="search-result-item" (click)="goToResult(r)">
              <i [class]="r.icon"></i>
              <div class="result-text">
                <span class="result-label">{{ r.label }}</span>
                <span class="result-sub">{{ r.sub }}</span>
              </div>
            </div>
          }
        </div>
      }
    </div>

    <!-- Language dropdown — scales to any number of languages -->
    <p-select
      [options]="languages"
      [ngModel]="selectedLang()"
      (ngModelChange)="onLangChange($event)"
      optionLabel="label"
      styleClass="lang-select"
      [showClear]="false"
    >
      <ng-template #selectedItem let-lang>
        <span class="lang-option">
          <span class="fi" [ngClass]="'fi-' + lang.flag"></span>
          <span class="lang-label">{{ lang.label }}</span>
        </span>
      </ng-template>
      <ng-template #item let-lang>
        <span class="lang-option">
          <span class="fi" [ngClass]="'fi-' + lang.flag"></span>
          <span>{{ lang.label }}</span>
        </span>
      </ng-template>
    </p-select>

    <app-notification-center />

    <button class="user-menu-trigger" (click)="userMenu.toggle($event)" aria-haspopup="true">
      @if (avatarImage()) {
        <p-avatar [image]="avatarImage()!" shape="circle" styleClass="topbar-avatar" />
      } @else {
        <p-avatar [label]="avatarInitials()" shape="circle" styleClass="topbar-avatar" />
      }
      <span class="user-name">{{ auth.currentUser()?.firstName }}</span>
      <i class="pi pi-angle-down user-caret"></i>
    </button>
    <p-menu #userMenu [model]="userMenuItems()" [popup]="true" appendTo="body" />

  </div>
</header>
